<template>
  <Modal v-model="showModal"
    scrollable
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    title="设置印鉴">
    <Form ref="setSealImageForm"
      label-position="left"
      :model="sealImage"
      :label-width="120">
      <FormItem label="选择印鉴图片" prop="sealImage" :rules="[{required:true,message:'请选择文件',trigger:'blur'}]">
        <img :src="sealImage.sealImage" v-if="sealImage.sealImage" width="200" />
        <br v-if="sealImage.sealImage">
        <input v-model="sealImage.sealImage" type="hidden" />
        <Button type="primary" @click="selectFile">选择图片</Button>
      </FormItem>
    </Form>
    <input type="file" ref="sealFileInput" @change="fileSelected" style="display:none">
    <div slot="footer">
      <Button type="success" @click="setSealImage">提交</Button>
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'sealimage-set-modal',
  props: {
    callback: Function,
    show: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      sealImage: {
        sealImage: null
      },
      currentFile: null
    }
  },
  computed: {
  },
  watch: {
    show: function (newVal) {
      this.showModal = newVal
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
      this.sealImage.sealImage = null
      this.$emit('close-modal')
    },
    setSealImage () {
      this.$refs['setSealImageForm'].validate(async (valid) => {
        if (valid) {
          if (this.currentFile && this.currentFile.name&&this.sealImage.sealImage) {
            this.$emit('set-sealimage', this.sealImage.sealImage)
            this.closeModal()
          }
        }
      })
    },
    selectFile () {
      // console.log(this.$refs['sealFileInput'])
      this.$refs['sealFileInput'].click()
    },
    fileSelected (e) {
      let files = e.target.files
      if (files && files.length) {
        let file = files[0]
        this.currentFile = file
        this.getBase64Image(this.currentFile)
      }
    },
    getBase64Image (imgFile) {
      let that = this
      let image = new Image()
      let reader = new FileReader()
      image.src = imgFile
      reader.onload = function (evt) {
        image.src = evt.target.result
        let base64 = evt.target.result
        that.sealImage.sealImage = base64
      }
      reader.readAsDataURL(imgFile)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
